"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BaseSlasher = void 0;
var address_1 = require("@celo/base/lib/address");
var connect_1 = require("@celo/connect");
var BaseWrapper_1 = require("./BaseWrapper");
var BaseWrapperForGoverning_1 = require("./BaseWrapperForGoverning");
var BaseSlasher = /** @class */ (function (_super) {
    __extends(BaseSlasher, _super);
    function BaseSlasher() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.slash = function () {
            var _a;
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            return (0, connect_1.toTransactionObject)(_this.connection, (_a = _this.contract.methods).slash.apply(_a, args));
        };
        /**
         * Returns slashing incentives.
         * @return Rewards and penalties for slashing.
         */
        _this.slashingIncentives = (0, BaseWrapper_1.proxyCall)(_this.contract.methods.slashingIncentives, undefined, function (res) { return ({
            reward: (0, BaseWrapper_1.valueToBigNumber)(res.reward),
            penalty: (0, BaseWrapper_1.valueToBigNumber)(res.penalty),
        }); });
        return _this;
    }
    BaseSlasher.prototype.signerIndexAtBlock = function (address, blockNumber) {
        return __awaiter(this, void 0, void 0, function () {
            var election, validators, validator, _a, _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0: return [4 /*yield*/, this.contracts.getElection()];
                    case 1:
                        election = _c.sent();
                        return [4 /*yield*/, this.contracts.getValidators()];
                    case 2:
                        validators = _c.sent();
                        return [4 /*yield*/, validators.getValidator(address, blockNumber)];
                    case 3:
                        validator = _c.sent();
                        _a = address_1.findAddressIndex;
                        _b = [validator.signer];
                        return [4 /*yield*/, election.getValidatorSigners(blockNumber)];
                    case 4: return [2 /*return*/, _a.apply(void 0, _b.concat([_c.sent()]))];
                }
            });
        });
    };
    BaseSlasher.prototype.trailingSlashArgs = function (address, blockNumber) {
        return __awaiter(this, void 0, void 0, function () {
            var validators, account, membership, incentives, lockedGold, lockedGoldValidatorSlash, lockedGoldValidatorGroupSlash;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.contracts.getValidators()];
                    case 1:
                        validators = _a.sent();
                        return [4 /*yield*/, validators.validatorSignerToAccount(address)];
                    case 2:
                        account = _a.sent();
                        return [4 /*yield*/, validators.getValidatorMembershipHistoryIndex(account, blockNumber)];
                    case 3:
                        membership = _a.sent();
                        return [4 /*yield*/, this.slashingIncentives()];
                    case 4:
                        incentives = _a.sent();
                        return [4 /*yield*/, this.contracts.getLockedGold()];
                    case 5:
                        lockedGold = _a.sent();
                        return [4 /*yield*/, lockedGold.computeInitialParametersForSlashing(account, incentives.penalty)];
                    case 6:
                        lockedGoldValidatorSlash = _a.sent();
                        return [4 /*yield*/, lockedGold.computeParametersForSlashing(membership.group, incentives.penalty, lockedGoldValidatorSlash.list)];
                    case 7:
                        lockedGoldValidatorGroupSlash = _a.sent();
                        return [2 /*return*/, [
                                membership.historyIndex,
                                lockedGoldValidatorSlash.lessers,
                                lockedGoldValidatorSlash.greaters,
                                lockedGoldValidatorSlash.indices,
                                lockedGoldValidatorGroupSlash.lessers,
                                lockedGoldValidatorGroupSlash.greaters,
                                lockedGoldValidatorGroupSlash.indices,
                            ]];
                }
            });
        });
    };
    return BaseSlasher;
}(BaseWrapperForGoverning_1.BaseWrapperForGoverning));
exports.BaseSlasher = BaseSlasher;
//# sourceMappingURL=BaseSlasher.js.map